// Health & Fitness configuration

export const HEALTH_CONFIG = {
  ENERGY_PER_KG_FAT_KCAL: 7700, // kcal per kg of fat mass
  ENERGY_PER_KG_LEAN_KCAL: 1100, // kcal per kg of lean mass (water/glycogen rich)
  EWMA_ALPHA_DEFAULT: 0.3,
  CUTOFF_06_ENABLED: true,
};


